export class LoggedOutException extends Error {}
